<template>
     <div class="home container p-3 mx-auto">
       <section>
        <div v-if="loading_flag==0">
          <section class="row m-0">
                <div class="col-md-3 d-none d-md-block ">
                      <img class="w-100" src="@/assets/Kworktech_logo_website_White.jpg">
                      <div class="email">
                        <div class=""><a href="mailto:george.browny@kaizenworktech.com">george.browny@kaizenworktech.com</a></div>
                        <div class=""><a href="mailto:raj.menon@kaizenworktech.com">raj.menon@kaizenworktech.com</a></div>
                      </div>
                </div>
                <div class="col-md-9 ">                 
                  <carousel class="row" :autoplay="true" :nav="false" :responsive="{0:{items:1,nav:false},720:{items:2,nav:false},1000:{items:3,nav:false}}">
                      <div class="p-2" v-if="productList.new[0]" >
                            <app-product-card  :pos="0"  v-bind:in_data="productList.new[0]"  v-on:storeSelProduct = "storeSelProduct" v-on:addProductList = "addProductWatchList" v-on:removeProductList = "removeProductWatchList" ></app-product-card>
                      </div> 
                      <div class="p-2" v-if="productList.new[1]" >
                            <app-product-card  :pos="1"  v-bind:in_data="productList.new[1]"  v-on:storeSelProduct = "storeSelProduct"  v-on:addProductList = "addProductWatchList" v-on:removeProductList = "removeProductWatchList" ></app-product-card>
                      </div> 
                      <div class="p-2" v-if="productList.new[2]" >
                            <app-product-card  :pos="2"  v-bind:in_data="productList.new[2]"  v-on:storeSelProduct = "storeSelProduct"  v-on:addProductList = "addProductWatchList" v-on:removeProductList = "removeProductWatchList"></app-product-card>
                      </div> 
                      <div class="p-2" v-if="productList.new[3]" >
                            <app-product-card  :pos="3"  v-bind:in_data="productList.new[3]"  v-on:storeSelProduct = "storeSelProduct"  v-on:addProductList = "addProductWatchList" v-on:removeProductList = "removeProductWatchList"></app-product-card>
                      </div> 
                      <div class="p-2" v-if="productList.new[4]" >
                            <app-product-card  :pos="4"  v-bind:in_data="productList.new[4]"  v-on:storeSelProduct = "storeSelProduct"  v-on:addProductList = "addProductWatchList" v-on:removeProductList = "removeProductWatchList"></app-product-card>
                      </div> 
                      <div class="p-2" v-if="productList.new[5]" >
                            <app-product-card  :pos="5"  v-bind:in_data="productList.new[5]"  v-on:storeSelProduct = "storeSelProduct"  v-on:addProductList = "addProductWatchList" v-on:removeProductList = "removeProductWatchList"></app-product-card>
                      </div> 
                  </carousel> 
                </div> 
          </section>
          <section :ref="home_nav" class="navbar sticky-top navbar-light bg-white row font-weight-bold p-0 pb-2 nav-bar">
            <div class="top-menu top-menu-borders border-top border-bottom border-dark col-md-12">
              <app-sm-side-nav class="d-block d-md-none pl-3" v-on:callProductList = "getProductList" :cat_sel_state ="cat_sel_state" :filter="filter"></app-sm-side-nav>
              <div class="offset-md-3 p-2 aboutus-block "> 
                  <div class=" watchlist-exist text-uppercase">
                    <a href="javascript:void(0)"><span @click="about()">About Us </span></a>
                  </div> 
              </div>
              <div class="offset-md-3 p-2 watchlist-block" data-toggle="modal" data-target="#isProductWatchList" v-if="productWatchList.length != 0"> 
                  <div class=" watchlist-exist">
                    <a href="javascript:void(0)"><span> MY COLLECTION </span> <span class="watchlistcount pl-2">{{this.productWatchList.length}}</span></a>
                  </div> 
              </div>
              <div class="offset-md-3 p-2 watchlist-block" v-if="productWatchList.length == 0">
                  <div class=" watchlist-none">
                    <span>MY COLLECTION </span> 
                  </div>
              </div> 
            </div>
          </section>
          <section class="row m-0">
            <div class="col-md-3 ">
                <app-side-nav class="d-none d-md-block pt-4" v-on:callProductList = "getProductList" :filter= "filter"></app-side-nav>
            </div>
            <div class="col-md-9 pt-4 container-body">
              <div class="row"> 
                <div class="col-lg-4 col-md-6 col-sm-6 col-12 p-2"  v-for="(product, i)  in productList.list" :key="product.brand_id">
                  <app-product-card :id="product.product_id" :pos="i" :in_data="product"   v-on:storeSelProduct = "storeSelProduct" v-on:addProductList = "addProductWatchList" v-on:removeProductList = "removeProductWatchList"></app-product-card>
                </div>
              </div>            
            </div>
          </section>
          <button @click="topFunction()"  title="Go to top">
            <a title="Back to top" id="myBtn" href="#">&#10148;</a>
          </button>
        </div>
        <div v-if="loading_flag==1">
          <!-- loading .... ..... -->
          <div class="text-center spinner-load" style="margin-top:25%">
            <MoonLoader class=""   :size="30" :sizeUnit="px"></MoonLoader>
          </div>
        </div>
       </section>
       <!-- modals -->
        <div class="modal fade" id="isProductWatchList" role="dialog">
          <div class="modal-dialog modal-lg">
              <div class="modal-content">
                  <div class="modal-header">
                      <button type="button" class="close" style="text-align: end;" data-dismiss="modal">
                          <img style="width:15%" src="@/assets/minimize.png">
                         <!-- --  -->
                      </button>
                      <h4 class="modal-title">Product WatchList </h4>
                  </div>
                  <div class="modal-body">
                      <div v-if="download_loading_flag == 1">
                        <div class="template-body tab-bg pt-2">
                            <div class="table-responsive pt-2">
                                <table  class="table border pt-2 text-uppercase">
                                  <tbody>
                                      <tr>
                                      <th>S No.</th>
                                      <th>Brand Name</th>
                                      <th>Product Name</th>
                                      <th>2D File</th>
                                      <th>3D File</th>
                                      <th>PDF</th>
                                      </tr>
                                  </tbody>
                                  <tbody>
                                      <tr  v-for="(product,index) in productWatchList" :key="index">
                                      
                                      <td > 
                                        <input type="checkbox"  :name="index+'row'" :id="index+'row'"  :checked="selected_download[index].row" v-model="selected_download[index].row" @change = "sel_dwn_prod($event,index)" >                              
                                        {{index+1}} </td>
                                      <td>{{product.brand_name}}</td>
                                      <td>{{product.product_name}}</td>
                                      <td>
                                              <input type="checkbox"  :name="index+'2d'" :id="index+'2d'"  v-if="!(selected_download[index].d_2d == status_hide)"  :checked="selected_download[index].d_2d" v-model="selected_download[index].d_2d">                                 
                                      </td>
                                      <td>
                                              <input type="checkbox" :name="index+'3d'" :id="index+'3d'"   v-if="!(selected_download[index].d_3d == status_hide)" :checked="selected_download[index].d_3d"  v-model="selected_download[index].d_3d">                            
                                      </td>
                                      <td>
                                              <input type="checkbox" :name="index+'pdf'" :id="index+'pdf'" :checked="selected_download[index].d_pdf"  v-model="selected_download[index].d_pdf"> 
                                      </td>                            
                                      </tr>
                                  </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="text-center p-3">
                            <button type="button" class="btn btn-primary" @click = "downloadZip" >DOWNLOAD NOW</button> 
                        </div>
                      </div>
                      <div v-if="download_loading_flag == 0" class="template-body tab-bg pt-2">
                        <!-- <div v-if="fileUpload.status==='progress'">
                          <div class="progress" style="height:20px;margin-bottom:20px">
                            <div class="progress-bar" role="progressbar" [style.width.%]="fileUpload.message">
                              {{fileUpload.message}}%
                            </div>
                          </div>
                        </div> -->
                        <!-- {{progressBar}}% -->
                           Let's exchange your patience and time for the requested files.
                          <!-- <vue-progress-bar></vue-progress-bar> -->
                            {{showpercentage}}
                          <div class="loading-bar">
                            <div class="percentage" :style="{'width': percentage + '%'}">
                            </div>
                          </div>
                          <!-- <div class="text-center spinner-load" style="margin-top:10px;margin-bottom:5px">
                              <MoonLoader class=""  :size="25" :sizeUnit="px"></MoonLoader>
                          </div> -->
                      </div>
                  </div>
                  <div class="modal-footer">
                  </div>
              </div>
          </div>
        </div>  
    </div> 
   
</template>

<script>
// components
import ProductCard from '@/components/common/product-card'
import sideNav from '@/components/layout/side-nav'
import smSideNav from '@/components/layout/sm-side-nav'
// import ProductView from '@/pages/site/Product'
import ProductService from '../../shared/services/product.service'
import carousel from 'vue-owl-carousel'
import {globalMixin,ontimeMixin} from '@/mixin.js'
import { VueSpinners } from '@saeris/vue-spinners'
// import ProgressBar from 'vuejs-progress-bar'
import ProgressBar from 'vue-simple-progress'

Vue.use(ProgressBar)
// import VueProgressBar from 'vue-progressbar'

// Vue.use(VueProgressBar, {
//   color: 'rgb(143, 255, 199)',
//   failedColor: 'red',
//   height: '10px !important',
//   width:'70% !important',
//   opacity: 'unset !important',
//   position: 'inherit !important',
//   top: 'unset !important',
//   left:'0px !important',
// })

import Vue from 'vue'
Vue.use(VueSpinners)
// Vue.use(VueProgressBar,options)
// const options = {
//   color: '#bffaf3',
//   failedColor: '#874b4b',
//   thickness: '5px',
//   transition: {
//     speed: '0.2s',
//     opacity: '0.6s',
//     termination: 300
//   },
//   autoRevert: true,
//   location: 'left',
//   inverse: false
// }

import { MoonLoader } from '@saeris/vue-spinners'



// Vue.use(VueProgressBar, {
//   color: 'rgb(143, 255, 199)',
//   failedColor: 'red',
//   height: '10px'
// })

const productService = new ProductService();
// var clearSetInverval ;
var intval ;

export default {
  mixins: [globalMixin,ontimeMixin],
  name: 'Home',
  components: {
    'app-product-card': ProductCard,
    // 'app-product-view': ProductView,
    'app-side-nav': sideNav,
    'app-sm-side-nav': smSideNav,
    'carousel': carousel,
    MoonLoader,
  },
  
  props: {
    msg: String,
    listData:Object
  },
   data() {
      return {
        productWatchList:this.$productWatchList,
        selected_download:this.$selected_download,
        productList:this.$store_app_data,
        cat_sel_state:this.get_last_cat_state(),
        sc_id:0,
        mc_id:0,
        loading_flag : 1,
        download_loading_flag : 1,
        select_collection:"My Collection",
        status_hide : 2,  //info: used to hide the check box while download,
        filter:{
            name:'/'
        },
        percentage:0,
        isProgressBarFinish:false,
        
        // options: {
        //   text: {
        //     color: '#FFFFFF',
        //     shadowEnable: true,
        //     shadowColor: '#000000',
        //     fontSize: 14,
        //     fontFamily: 'Helvetica',
        //     dynamicPosition: false,
        //     hideText: false
        //   },
        //   progress: {
        //     color: '#2dbd2d',
        //     backgroundColor: '#333333',
        //     inverted: false
        //   },
        //   layout: {
        //     height: 35,
        //     width: 140,
        //     verticalTextAlign: 61,
        //     horizontalTextAlign: 43,
        //     zeroOffset: 0,
        //     strokeWidth: 30,
        //     progressPadding: 0,
        //     type: 'line'
        //   }
        // }
      }
    },
  computed:{
    showpercentage(){
      return this.percentage.toFixed();
    }
  },
  methods: {
    topFunction() {
                window.scroll({
                   top: document.body.scrollTop,
                    behavior: 'smooth'
                });
      },
      getProductList(mc_id,sc_id) {
        this.productList.list=[];
        this.set_last_cat_state(mc_id,sc_id);
        productService.getProductList(mc_id,sc_id)
        .then(response => {
          this.productList = response.data.output.success[0].data;
          this.productList = this.check_is_sel_prod(this.productList);
          this.topFunction();
        })
        .catch(e => {
          this.errors.push(e)
        }) 
        
        // this.setCollection(sel_name);
      },

      goto(){
                this.goto_last_product();
      },
      // topFunction(){
      //   document.body.scrollHeight = 0;
      //   document.documentElement.scrollHeight = 0;
      //                 console.log("hello top function")
      // },
      
      // getElement()
      // {
      //         console.log("hello getelement")
      //         return document.getElementById("myBtn")


      // },

      // scrollFunction() {
      //   if (document.body.scrollHeight > 20 || document.documentElement.scrollHeight > 20) {
      //     this.getElement().style.display = "block";
      //     console.log("scroll funciton block")
      //   } else {
      //     console.log("scroll funciton none")
      //     this.getElement().style.display = "none";
      //   }
      // },

      // addProductWatchList(product,i){

      //   let index =  this.productWatchList.findIndex(obj => obj.product_id == product.product_id);

      //   // info: check if 3d or 2d file exists
      //   let status_2d = (product.twod_file_url)? true: this.status_hide;
      //   let status_3d = (product.threed_file_url)? true: this.status_hide;

      //   if (index === -1){
      //     this.selected_download.push({
      //         'product_id' : product.product_id,
      //         'row' : true,
      //         'd_2d' : status_2d,
      //         'd_3d' : status_3d,
      //         'd_pdf' : true
      //         });

      //     this.productWatchList.push(product)

      //     if(product.product_status){ //info: product_status if 'new'
      //       this.productList.new[i]['selected'] = 1;
      //       let p_list_pos =  this.productList.list.findIndex(obj => obj.product_id == product.product_id);
      //         if(p_list_pos > -1)
      //           this.productList.list[p_list_pos]['selected'] = 1;
      //     }else{
      //       this.productList.list[i]['selected'] = 1;
      //       let p_new_pos =  this.productList.new.findIndex(obj => obj.product_id == product.product_id);
      //         if(p_new_pos > -1)
      //           this.productList.new[p_new_pos]['selected'] = 1;
      //     }


      //     // this.productList.list[i]['selected'] = 1;
      //     // this.productList.new[i]['selected'] = 1;

      //   }

      // },
      
      // removeProductWatchList(product,i){
      //   let index =  this.productWatchList.findIndex(obj => obj.product_id == product.product_id)

      //   if (index > -1) {
      //     this.productWatchList.splice(index, 1);
      //     // this.productList.list[i]['selected'] = 0;

      //     if(product.product_status){ //info: product_status if 'new'
      //       this.productList.new[i]['selected'] = 0;
      //       let p_list_pos =  this.productList.list.findIndex(obj => obj.product_id == product.product_id);
      //         if(p_list_pos > -1)
      //           this.productList.list[p_list_pos]['selected'] = 0;
      //     }else{
      //       this.productList.list[i]['selected'] = 0;
      //       let p_new_pos =  this.productList.new.findIndex(obj => obj.product_id == product.product_id);
      //         if(p_new_pos > -1)
      //           this.productList.new[p_new_pos]['selected'] = 0;
      //     }
      //   }

      // },

      storeSelProduct(product,i){
        // :to="'product/'+in_data.product_id"
        this.set_store_sel_product(product,i);
        this.$router.push({path:'product/'+product.product_id})

      },

      // IncreaseProgressBar(){
      //     var elem = document.getElementById("myBar");   
      //     console.log('Progresbarcount',this.progressBar);
      //     if(this.progressBar == 98){
      //       clearInterval(clearSetInverval)
      //       this.progressBar = 98;
      //     }            
      //     else if(this.isProgressBarFinish == false){
      //       this.progressBar = 100;
      //     }
      //     else {
      //         this.ProgressBar = this.progressBar + 5;
      //         elem.style.width = this.ProgressBar + '%'; 
      //     }
      //     console.log('Progresbarcount',this.progressBar);
      // },
      Start(){
        this.percentage = 0;
        clearInterval(intval)
        intval = setInterval(()=>{
                          if(this.percentage < 100){                            
                            if(this.percentage == 80){
                              if(this.isProgressBarFinish){
                                this.percentage = 100;
                                clearInterval(intval)
                              }
                              else{
                                this.percentage = 80;
                                // clearInterval(this.intval)
                                this.waitTodownload(this.percentage)
                              }
                            }                                                    
                            else{
                              this.percentage += 2; 
                            }
                          }
                          else if(this.isProgressBarFinish){
                            this.percentage = 100;
                            setTimeout(() => {
                              clearInterval(intval)
                            }, 1000);
                          }                          
                          else{
                            setTimeout(() => {
                              clearInterval(intval)
                            }, 1000);
                          }
                        },10)
      },
      finish(){
        console.log('ececute finish method')
        this.percentage = 100 
        setTimeout(() => {
                this.isProgressBarFinish = true; 
                this.download_loading_flag = 1;
        }, 1000); 
      },
      waitTodownload(){
        let waitinterval = setInterval(()=>{
            if(this.isProgressBarFinish){
              this.percentage = 100;
              setTimeout(() => {
                  clearInterval(intval)
                  clearInterval(waitinterval) 
              }, 1000);              
            }
        },1000)
      },
      

      
 
      downloadZip(){

          this.download_loading_flag = 0;
          let obj = {"product_list" : this.selected_download};
          // this.$Progress.start()
          this.Start();
          // console.log('progressbar is',this.$Progress);
          productService.downloadZip(obj)
          .then( async response => {
            console.log('responseis',response);
            const blob = new Blob([response.data], { type: 'application/zip' })
            const link = document.createElement('a')
            console.log('link is',link);
            link.href = URL.createObjectURL(blob)
            link.download = "kworktech.zip"
            console.log("downlod ducment is",link.download)           

            link.click()
            console.log("downlod ducment is",link.click(),URL.revokeObjectURL(link.href))
            URL.revokeObjectURL(link.href)
            response => this.fileUpload = response
            console.log('response is',response);
            // this.$Progress.finish()
            this.finish();

          })
          .catch(e => {
          this.download_loading_flag = 1;

              this.toast.error("Error occured while adding",{
                  position:'top-right'
              })  
                this.errors.push(e)
          })

      },

      sel_dwn_prod(e,pos){
        let status = e.target.checked;

        if(this.selected_download[pos].d_2d != this.status_hide) 
          this.selected_download[pos].d_2d = status;

        if(this.selected_download[pos].d_3d != this.status_hide) 
          this.selected_download[pos].d_3d = status;

          this.selected_download[pos].d_pdf = status ;
      },

      setCollection(sel_name){
        this.select_collection = sel_name;
      },

      setProductList(){
           console.log("this is setProductList outside .... ",this);
      },
      
      set_loading_flag(flag){
           console.log("this is set_loading_flag outside .... ",flag);
           this.loading_flag = flag;
      },

      about(){
           this.$router.push({path:'/about'})
      },
      //  displayPrgressbar(){
      //      this.percentage = 0;
      //       let intval = setInterval(()=>{
      //                     if(this.percentage < 100){                            
      //                       if(this.percentage == 90){
      //                         if(this.isProgressBarFinish){
      //                           this.percentage = 100;
      //                           clearInterval(intval)
      //                         }
      //                         else{
      //                             this.percentage = 98;
      //                             setInterval(()=>{
      //                               if(this.isProgressBarFinish){
      //                                 clearInterval(intval)
      //                               }
      //                             },15000)
      //                         }
      //                       }                                                    
      //                       else{
      //                         this.percentage += 2; 
      //                       }
      //                     }
      //                     else if(this.isProgressBarFinish){
      //                       this.percentage = 100;
      //                       setTimeout(() => {
      //                         clearInterval(intval)
      //                       }, 10);
      //                     }                          
      //                     else{
      //                       clearInterval(intval)
      //                     }
      //                   },10)
      // }
  },
  
  created() {

    // this.displayPrgressbar()
    // this.logMsg();
    // this.setStatus(2);
    // this.logMsg();
   
    let loc_this =this;
    console.log("this is outside .... ",this);

    
    console.log("first_status",this.$first_status);
    console.log("appName",this.productList);

    if(this.$first_status){
      // this.getProductList(this.mc_id,this.sc_id);
        let out_data;

       productService.getProductList(this.mc_id,this.sc_id)
      .then( (response) => {
        
        console.log(loc_this,"this is inside .... ",this);

              out_data = response.data.output.success[0].data;
              this.set_loading_flag(0);
              this.productList = out_data;

              // if(this.productList.new){
              //   this.productList.new.forEach(element => {
              //       element['product_status']='new' 
              //   });
              // this.set_first_status(0);
              // }
              this.set_first_status(0);
              this.set_store_app_data(this.productList);

      })
      .catch((e) => {
      loc_this.errors.push(e)
      })  

      

    }else{
      this.productList = this.$store_app_data;
      this.set_loading_flag(0);
    }

    // this.getElement();
    // window.onscroll = function() {this.scrollFunction()};

    
  },
  
 
  mounted(){
    // this.$nextTick(function () {
    //     // DOM is now updated
    //     // `this` is bound to the current instance
    //     this.goto_last_product();
    //   })
      this.goto();
      // window.onscroll = function() {this.scrollFunction()}
   
  }
}

</script>
<style  scoped>

  @import '../../style.css';

  /* template{
    padding:2%;
  } */

  .navbar{
    padding-right:23px !important;
  }

  .watchlistcount{
    color: green;
  }

  .watchlist-exist{
    color:#000000
  }
  .watchlist-none{
    color: #858585
  }
  a, a:hover{
    color:#000000
  }
  .logo{
    width:120%;
    margin-left:-10%;
    min-height:60%;
    margin-top:5%;
  }

/* make design for watchlist for web adn mobile view */
.top-menu{
  display: flex;
}
  .watchlist-block{
    margin-left: auto;
  }

.email{
    font-size: 12px;
    font-family: Barlow, 'san-serif';
    margin-top: -6%;
}

.top-menu-borders{
  margin-left:0px !important;
}

@media(max-width:600px){
  .navbar{
    padding-right: unset !important;
    padding:0.75rem !important;
  }
  .top-menu{
    padding-right: unset !important;
  }
    /* .top-menu-borders{
        margin-left: -16px !important;
        margin-right: -17px !important;
    } */
  }



.sticky-top{
  top:-2px;
}
 .nav-bar{
   margin-left: 11px;
   display: flow-root !important;
 }
 .nav-bar-items{
   margin-right: 23px;
 }

 @media(max-width:600px){
     .nav-bar{
        margin-left: 0px;
      }
      .watchlist-block{
        margin-right: 5px;
      }
  }

  
  @media(max-width: 767px){
    .aboutus-block{
      margin-left: auto;
    }
  }
 

  #myBtn {
    /* display: none; */
    position: fixed;
    bottom: 20px;
    right: 30px;
    z-index: 99;
    font-size: 15px;
    border: none;
    outline: none;
    background-color: #858585;
    color: white;
    cursor: pointer;
    padding: 15px;
    /* border-radius: 4px; */
    -moz-transform: rotate(270deg);
    -webkit-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
    text-decoration:none;
  }
  #myBtn:hover {
    background-color: #858585;
  }
  /* #myBtn {
    width: 40px;
    line-height: 40px;
    overflow: hidden;
    z-index: 999;
    display: none;
    cursor: pointer;
    -moz-transform: rotate(270deg);
    -webkit-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
    position: fixed;
    bottom: 50px;
    right: 0;
    background-color: #DDD;
    color: #555;
    text-align: center;
    font-size: 30px;
    text-decoration: none;
} */
/* #myBtn:hover {
    background-color: #DDF;
    color: #000;
} */
/* @media(min-width:767px){
  .top-nav-corosul{
    margin-left:0px;
    margin-right:0px
  }
  .nav-bar-custom{
    width:100% !important;
    margin-left:0px !important;
  }
  .top-nav-corosul-body{
    padding-right:0px;
    padding-left:20px
  }
  .home-main{
    margin-left:0px;
    margin-right:-10px
  }
  .home-body{
    margin-left:0px;
  }
}

@media(max-width: 767px){
  .nav-bar-custom{
    margin-right:-18px;
  }
  .home-body{
    margin-left:-4px;
    margin-right: 4px;
  }
} */
.spinner-load{
  display: flex;
  justify-content: center;
}
.email{
  margin-left: 20px;
}
@media(min-width: 768px) and (max-width: 768px){
  .email{
    margin-left: unset !important;
    font-size: 12px;
    font-family: Barlow, 'san-serif';
    margin-top: -6%;
  }
}
.w3-green{
  max-height: 30px !important;
  width:0px !
}

.loading-bar{
  position: relative;
  width:100% !important;
  height: 20px !important;
  border-radius: 15px !important;
  overflow: hidden;
  border-bottom: 1px solid #ddd !important;
  box-shadow: inset 0 1px 2px rgba(#000, .4),
                    0 -1px 1px #fff, 0 1px 0 #fff
}

.loading-bar .percentage{
  position: absolute !important;
  top:1px ; left:1px; right: 1px;
  display: block !important;
  height: 100% !important;
  /* width:100% !important; */
  border-radius: 15px !important;
  background-color: #a5df41 !important;
  background-size: 30px 30px;
  background-image: linear-gradient(135deg,rgba(#fff,.15) 25%,
                      transparent 50%,rgba(#fff, .15) 50%,
                      rgba(#fff,.15) 75%, transparent 75%,
                      transparent);
  animation: animate-stripes 3s linear infinite;                      
}
@keyframes animate-stripes {
  0%{
    background-position: 0 0;
  }
  100%{
    background-position: 100px 0;
  }
}
</style>